import { Sheet } from "@rosc/ui/v32/sheet";
import type { ComponentProps, JSX } from "react";
import { useTranslation } from "react-i18next";

// The v3.2 drawer is @rosc/ui's Sheet (packages/ui/src/v32/sheet.tsx): from
// the right on tablets and desktop, a bottom sheet with a grabber on
// phones. This wrapper only supplies the translated Close label.
export const V3Drawer = ({
  closeLabel,
  ...props
}: Omit<ComponentProps<typeof Sheet>, "closeLabel"> & {
  closeLabel?: string;
}): JSX.Element => {
  const { t } = useTranslation();
  return <Sheet closeLabel={closeLabel ?? t("common.close")} {...props} />;
};
